import React from 'react';


export default function Hero({ affiliateLink, handleCTA })
{
    return(
         <footer className="py-4 border-top bg-white">
        <div className="container d-flex flex-column flex-lg-row justify-content-between align-items-center gap-2">
          <div className="small text-muted">© {new Date().getFullYear()} Tempo+ Produtividade — Todos os direitos reservados.</div>
          <div className="small text-muted">Política de Privacidade • Termos de Uso</div>
        </div>
      </footer>
    )
}